
import { defineComponent } from 'vue'
import { getBasicData, getAd, BasicDataDto } from '@/api/home'
import { getOccupationLevelPieStatistics } from '@/api/insurance'
import { hasAppFeature } from '@/api/base'
import alertBox from '@/components/alert-box.vue'
import global from '@/utils/global'
import * as echarts from 'echarts'

export default defineComponent({
    name: 'HomeDetail',
    components: {
        'alert-box': alertBox
    },
    data () {
        return {
            data: {} as BasicDataDto,
            ad: [],
            adShow: false,
            isExportBill: false,
            billMonth: '',
            level1to3: { count: 0, ratio: '0.0' },
            level4: { count: 0, ratio: '0.0' },
            level5: { count: 0, ratio: '0.0' }
        }
    },
    async created () {
        this.data = await getBasicData()
        const adRes = await getAd({ source: 'pc' })
        this.ad = adRes
        if (adRes.length > 0) {
            this.adShow = true
        }
        this.getPieData()
    },
    methods: {
        hasAppFeature,
        jumpInfo (path: string) {
            window.open(path, '_blank')
        },
        openExportBill () {
            this.billMonth = ''
            this.isExportBill = true
        },
        onExportBill () {
            if (!this.billMonth) {
                this.$message.error('请选择月份')
                return
            }
            window.location.href =
                process.env.VUE_APP_BASE_URL +
                '/policy/exportBill/?month=' +
                this.billMonth +
                '&token=' +
                global.token
            this.$message.success('导出成功')
            this.isExportBill = false
        },
        async getPieData () {
            const res = await getOccupationLevelPieStatistics({ onlyActive: '1' })
            let count1to3 = 0
            let count4 = 0
            let count5 = 0
            let countOther = 0
            let total = 0

            res.forEach(item => {
                const count = Number(item.count)
                const name = item.name ? item.name.trim() : ''
                total += count
                if (['1类', '2类', '3类', '1', '2', '3', '1-3类'].includes(name) || /^[1-3]类/.test(name)) {
                    count1to3 += count
                } else if (['4类', '4'].includes(name) || /^4类/.test(name)) {
                    count4 += count
                } else if (['5类', '5', '超5类'].includes(name) || /5类/.test(name)) {
                    count5 += count
                } else {
                    countOther += count
                }
            })

            if (total > 0) {
                this.level1to3 = {
                    count: count1to3,
                    ratio: (count1to3 / total * 100).toFixed(1)
                }
                this.level4 = {
                    count: count4,
                    ratio: (count4 / total * 100).toFixed(1)
                }
                this.level5 = {
                    count: count5,
                    ratio: (count5 / total * 100).toFixed(1)
                }
            }

            const chartData = [
                { value: count1to3, name: '1-3类' },
                { value: count4, name: '4类' },
                { value: count5, name: '5类' }
            ]
            if (countOther > 0) {
                chartData.push({ value: countOther, name: '其他' })
            }

            this.$nextTick(() => {
                setTimeout(() => {
                    this.initChart(chartData)
                }, 200)
            })
        },
        initChart (data: { value: number; name: string }[]) {
            const chartDom = this.$refs.miniPie as HTMLElement
            if (!chartDom) return
            let myChart = echarts.getInstanceByDom(chartDom)
            if (myChart) {
                myChart.dispose()
            }
            myChart = echarts.init(chartDom)
            const option = {
                color: ['#00D679', '#FAC858', '#EE6666'],
                series: [
                    {
                        name: '风险等级',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: false
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: data
                    }
                ]
            }
            myChart.setOption(option)
        }
    }
})
